import { Form, Input, Select, Checkbox } from 'antd';
import * as xmljs from 'xml2js';
import React, { useEffect, useState, useCallback } from 'react';
import { Http } from '../../../../helpers/axois';
import style from './deployment.module.sass';
import formValidation from '../../../../utils/deployment-form-validation';

const { Option } = Select;
interface Props {
    appDetails: any
    currentDeploy: any
    data: any
    envList: any
    setIsFormSelected: any;
    setDmnDeploy: any;
    dmnDeploy: boolean
    capabilities: any
}

const LiveDeployment: React.FC<Props> = (props) => {
    const [count, setcount] = useState(0);
    const [bpnmList, setbpnmList] = useState<any[]>([]);
    const appId = props.appDetails && props.appDetails.appId;

    const getBpmn = useCallback(() => {
        Http.get(`apps/${appId}/bpmn?versionId=${props.appDetails.version_id}`).subscribe((res: any) => {
            setbpnmList(res);
        })
    }, [props, appId])

    const list = props.envList

    useEffect(() => {
        if (count === 0) {
            getBpmn();
            setcount(1)
        }
    }, [count, props, getBpmn]);

    const handleChange = async (e: any) => {
        props.setIsFormSelected(true)
        props.data('bpmnId', e)
        const data = bpnmList.filter(el => el.bpmnId === e);
        const formsource = data[0].source;
        const parsedXML: any = await xmljs.parseStringPromise(formsource);
        const findTask = parsedXML["bpmn:definitions"]["bpmn:process"][0]
        let isValidForm = true;
        if (bpnmList && bpnmList.length > 0) {
            isValidForm = formValidation(findTask, isValidForm)
        }
        props.setIsFormSelected(isValidForm)
    }

    return (
        <React.Fragment>
            <div className={'override-content row'}>
                {props.appDetails && props.appDetails.type === 'a8flow' && <div className='col-md-12'>
                    <Form.Item
                        label={"Journey"}
                    >
                        <Select data-test-id="bpmn_list" onChange={handleChange} style={{ width: '100%' }} loading={!bpnmList}>
                            {
                                bpnmList && bpnmList.length > 0 && bpnmList.map((data: any, key: number) => {
                                    return (
                                        <Option data-test-id={`bpmn_id${data.bpmnName}`} value={data.bpmnId} key={key}>{data.bpmnName}</Option>
                                    );
                                })
                            }
                        </Select>
                    </Form.Item>
                </div>}
                {!props.capabilities && <div className='col-md-12'>
                    <Form.Item
                        label={"Environment"}
                    >
                        <Select data-test-id="bpmn_env" placeholder="Testing"
                            onChange={(e: string) => props.data("envId", e)} style={{ width: '100%' }}>
                            {
                                list && list.length > 0 && list.map((data: any, key: number) => {
                                    return (
                                        <Option data-test-id={`bpmn_env_name${data.name}`} value={data.id} key={key}>
                                            {data.name}
                                            &nbsp;<small className={style.evnHost}>({data.url})</small>
                                        </Option>
                                    );
                                })
                            }
                        </Select>
                    </Form.Item>
                </div>}
                <div className='col-md-12'>
                    <Form.Item>
                        <Checkbox value={props.dmnDeploy} onChange={(e) => props.setDmnDeploy(e.target.checked)}>Deploy DMNs</Checkbox>
                    </Form.Item>
                </div>
            </div>
        </React.Fragment>
    )
}

export default LiveDeployment;